import { useEffect, useState } from "react"
import { FaArrowLeft, FaBackward, FaEdit, FaInfoCircle, FaPlus, FaSpinner, FaTimes, FaTrash } from "react-icons/fa"
import { BACKEND } from "../../config/configEnvs"
import axios from "axios"
import { Button, Pagination } from "@mui/material"
import { toast } from "react-toastify"
import Modal from "../ui/Modal"
import SearchIcon from '@mui/icons-material/Search';
import { Add } from "@mui/icons-material"


const TablaPlantillas = ({ limit }) => {

  const [page, setPage] = useState(1) // Pagina actual
  const [totalDocs, setTotalDocs] = useState(1) // Total de documentos
  const [totalPages, setTotalPages] = useState(1) // Total de paginas

  const [workers, setWorkers] = useState([])   // Trabajadores

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga

  const [surveys, setSurveys] = useState([]) // Encuestas

  const [isSurveySelected, setIsSurveySelected] = useState(false) // Hay encuesta seleccionada?
  const [selectedSurvey, setSelectedSurvey] = useState({}) // Objeto de encuesta seleccionada

  const [modifyQuestionModal, setModifyQuestionModal] = useState(false) // Modal de modificación de pregunta
  const [questionSelected, setQuestionSelected]  = useState({}) // Pregunta seleccionada

  const getWorkers = async () => { // Obtener la lista de trabajadores
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?where[activo][equals]=true&limit=0`)
      setWorkers(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const getSurveys = async () => { // Obtenemos todas las plantillas de las encuestas
    try {
      setLoadingStatus(true)
      const response = await axios.get(`${BACKEND}/api/getSurveys/getSurveyData?page=${page}&limit=${limit}`)

      setSurveys(response.data.surveys)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (error) {
      toast.error("Error al obtener las encuestas")
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  useEffect(() => {
    getSurveys()
    getWorkers()
  }, [])

  useEffect(() => {
    getSurveys()
  }, [page, limit])

  /// Crear nuevas preguntas y asignarlas a la encuesta modificando la plantilla

  const [newQuestionModal, setNewQuestionModal] = useState(false)

  const [newQuestionForm, setNewQuestionForm] = useState({
    type: "Respuesta abierta",
    worker: "",
    description: "",
    maxScore: 5
  })

  const [questionToModForm, setQuestionToModForm] = useState({
    survey: selectedSurvey.id,
    type: questionSelected.type,
    worker: questionSelected.worker?.id,
    description: questionSelected.description,
    maxScore: 5
  })

  useEffect(() => {
    setNewQuestionForm((prev) => ({
      ...prev,
      survey: selectedSurvey.id,
    }));
  }, [selectedSurvey]);

  useEffect(() => {
    setQuestionToModForm({
      survey: selectedSurvey.id,
      type: questionSelected.type,
      worker: questionSelected.worker?.id,
      description: questionSelected.description,
      maxScore: 5
    })
  }, [questionSelected])

  const createNewQuestion = async () => { // Crear nueva pregunta
    try {
      const responseQuestion = await axios.post(`${BACKEND}/api/encuestaSatisfaccionPregunta`, newQuestionForm);
  
      // Actualiza el estado de selectedSurvey
      setSelectedSurvey((prev) => ({
        ...prev,
        questions: [...prev.questions, responseQuestion.data.doc], // Añade la nueva pregunta al array
      }));
  
      // Actualiza el array surveys
      setSurveys((prevSurveys) =>
        prevSurveys.map((survey) =>
          survey._id === selectedSurvey._id // Compara el ID para encontrar la encuesta correcta
            ? {
                ...survey,
                questions: [...survey.questions, responseQuestion.data.doc], // Actualiza el array questions
              }
            : survey // Mantén el resto igual
        )
      );
      toast.success("Exito al guardar la nueva pregunta")
    } catch (error) {
      console.log(error);
      toast.error("Error al postear la pregunta");
    }
  };

  const updateQuestion = async () => { // Actualizar pregunta
    try {
      const response = await axios.put(
        `${BACKEND}/api/encuestaSatisfaccionPregunta/${questionSelected.id}`,
        questionToModForm
      );
  
      setSurveys((prevSurveys) => {
        const updatedSurveys = prevSurveys.map((survey) =>
          survey.id === selectedSurvey.id // Encuentra la encuesta correcta
            ? {
                ...survey,
                questions: survey.questions.map((question) =>
                  question.id === response.data.doc.id // Encuentra la pregunta correcta
                    ? response.data.doc // Actualiza la pregunta
                    : question // Mantén el resto igual
                ),
              }
            : survey // Mantén el resto igual
        );
  
        // Actualiza `selectedSurvey` con la encuesta recién modificada
        const updatedSelectedSurvey = updatedSurveys.find(
          (survey) => survey.id === selectedSurvey.id
        );
        setSelectedSurvey(updatedSelectedSurvey);
  
        return updatedSurveys; // Actualiza el estado de `surveys`
      });
  
      toast.success("Pregunta actualizada con éxito");
    } catch (error) {
      console.log(error);
      toast.error("Error al actualizar la pregunta");
    }
  };

  const deleteQuestion = async (questionId) => { // Eliminar pregunta
    try {
      const verifyQuestion = await axios.get(`${BACKEND}/api/getSurveys/verifyQuestion?questionId=${questionId}`)

      if (verifyQuestion.data.questionInUse) {
        return (
          toast.warning("La pregunta esta en uso en un formulario asignado a un cliente, no es posible eliminarla")
        )
      } else {
        const response = await axios.delete(`${BACKEND}/api/encuestaSatisfaccionPregunta/${questionId}`);
    
        setSurveys((prevSurveys) => {
          const updatedSurveys = prevSurveys.map((survey) =>
            survey.id === selectedSurvey.id // Encuentra la encuesta correcta
              ? {
                  ...survey,
                  questions: survey.questions.filter((question) => question.id !== questionId), // Elimina la pregunta
                }
              : survey // Mantén el resto igual
          );
    
          // Actualiza `selectedSurvey` con la encuesta recién modificada
          const updatedSelectedSurvey = updatedSurveys.find(
            (survey) => survey.id === selectedSurvey.id
          );
          setSelectedSurvey(updatedSelectedSurvey);
    
          return updatedSurveys; // Actualiza el estado de `surveys`
        });
    
        toast.success("Pregunta eliminada con éxito");
      }

    } catch (error) {
      console.log(error);
      toast.error("Error al eliminar la pregunta: " + error);
    }
  };

  // Nueva encuesta
  const [newSurveyModal, setNewSurveyModal] = useState(false)

  const [newSurveyForm, setNewSurveyForm] = useState({
    title: "",
    description: ""
  })

  const createSurvey = async () => {
    if (newSurveyForm.title === "") {
      toast.warning("Debes ingresar el título de la encuesta");
      return;
    }
  
    if (newSurveyForm.description === "") {
      toast.warning("Debes ingresar la descripción de la encuesta");
      return;
    }
  
    try {
      const response = await axios.post(`${BACKEND}/api/encuestaSatisfaccion`, newSurveyForm);
  
      setNewSurveyModal(false);
      getSurveys()
  
      setNewSurveyForm({
        title: "",
        description: ""
      });
  
      toast.success("Encuesta creada exitosamente");
    } catch (error) {
      console.error(error);
      toast.error("Error al crear la nueva encuesta: " + error.message);
    }
  };
  
  const deleteSurvey = async (id) => {
    try {
      const verifySurvey = await axios.get(`${BACKEND}/api/getSurveys/verifySurvey?surveyId=${id}`)

      if (verifySurvey.data.surveyInUse) {
        console.log("En uso")
        return (
          toast.warning("Esta encuesta ya ha sido asignada a uno o mas clientes, no es posible eliminar")
        )
      } else {
        await axios.delete(`${BACKEND}/api/encuestaSatisfaccion/${id}`);
      
        getSurveys()
        
        toast.success("Encuesta eliminada con éxito");
      }

    } catch (e) {
      console.error(e);
      toast.error("Error al eliminar la encuesta: " + e.message);
    }
  };

  // Modificar título y descripción de la encuesta

  const [surveyInfoModal, setSurveyInfoModal] = useState(false)

  const [surveyToModForm, setSurveyToModForm] = useState({
    title: selectedSurvey.title,
    description: selectedSurvey.description
  })

  const updateSurvey = async () => {
    try {
      const response = await axios.put(`${BACKEND}/api/encuestaSatisfaccion/${selectedSurvey.id}`, surveyToModForm)

      console.log(response)

      const updatedSurvey = response.data.doc;

      setSelectedSurvey((prev =>({...prev, title: updatedSurvey.title, description: updatedSurvey.description })))
      toast.success("Encuesta actualizada con éxito");

    } catch (error) {
      toast.error("Error al modificar los datos de la encuesta")
    }
  }
  
  useEffect(() => {
    setSurveyToModForm({
      title: selectedSurvey.title,
      description: selectedSurvey.description,
    })
  }, [selectedSurvey])
  
  return (
    <>
      <Modal
        title="Agregar pregunta"
        activeModal={newQuestionModal}
        onClose={() => setNewQuestionModal(false)}
        centered
      >
        <div className="flex flex-col gap-8">
          <span className="text-xs font-bold text-center">Ingresa la información para generar una nueva pregunta y asignarla a esta encuesta</span>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Pregunta</span>
            <textarea
              type="text"
              placeholder="Descripción de la pregunta"
              onChange={(e) => setNewQuestionForm((prev) => ({...prev, description: e.target.value}))}
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Tipo de respuesta</span>
            <select
              onChange={(e) => setNewQuestionForm((prev) => ({...prev, type: e.target.value}))}
              className="hover:cursor-pointer w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            >
              <option value="Respuesta abierta">Respuesta abierta</option>
              <option value="Respuesta cerrada">Respuesta cerrada</option>
            </select>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Trabajador</span>
            <select
              onChange={(e) => setNewQuestionForm((prev) => ({...prev, worker: e.target.value}))}
              className="hover:cursor-pointer w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            >
              <option value="Seleccionar">Seleccionar</option>
              {workers.map((worker) => (
                <option value={worker.id}>{worker.name}</option>
              ))}
            </select>
          </div>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => {
              createNewQuestion()
              setNewQuestionModal(false)
            }}
          >
            Crear pregunta
          </Button>
          
        </div>
      </Modal>

      <Modal
        title="Editar pregunta"
        activeModal={modifyQuestionModal}
        onClose={() => {
          setModifyQuestionModal(false)
          setQuestionSelected({})
        }}
        centered
      >
        <div className="flex flex-col gap-8">
          <span className="text-xs font-bold text-center">Modifica la información correspondiente</span>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Pregunta</span>
            <textarea
              value={questionToModForm.description}
              placeholder="Descripción de la pregunta"
              onChange={(e) =>
                setQuestionToModForm((prev) => ({ ...prev, description: e.target.value }))
              }
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Tipo de respuesta</span>
            <select
              value={questionToModForm.type}
              onChange={(e) => setQuestionToModForm((prev) => ({...prev, type: e.target.value}))}
              className="hover:cursor-pointer w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            >
              <option value="Respuesta abierta">Respuesta abierta</option>
              <option value="Respuesta cerrada">Respuesta cerrada</option>
            </select>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Trabajador</span>
            <select
              value={questionToModForm.worker}
              onChange={(e) => setQuestionToModForm((prev) => ({...prev, worker: e.target.value}))}
              className="hover:cursor-pointer w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            >
              <option value="Seleccionar">Seleccionar</option>
              {workers.map((worker) => (
                <option value={worker.id}>{worker.name}</option>
              ))}
            </select>
          </div>

          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => {
              updateQuestion()
              setModifyQuestionModal(false)
            }}
          >
            Actualizar pregunta
          </Button>
          
        </div>
      </Modal>

      <Modal
        title="Nueva encuesta"
        activeModal={newSurveyModal}
        onClose={() => setNewSurveyModal(false)}
        centered
      >
        <div className="flex flex-col gap-8">
          <span className="text-xs font-bold text-center">Ingresa la información de la nueva encuesta</span>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Título</span>
            <input
              type="text"
              placeholder="Título de la encuesta"
              onChange={(e) => setNewSurveyForm((prev) => ({...prev, title: e.target.value}))}
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Descripción</span>
            <textarea
              type="text"
              placeholder="Descripción de la encuesta"
              onChange={(e) => setNewSurveyForm((prev) => ({...prev, description: e.target.value}))}
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>


          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => createSurvey()}
          >
            Crear encuesta
          </Button>
          
        </div>
      </Modal>

      <Modal
        title="Editar título y descripción de la encuesta"
        activeModal={surveyInfoModal}
        onClose={() => setSurveyInfoModal(false)}
        centered
      >
        <div className="flex flex-col gap-8">
          <span className="text-xs font-bold text-center">Modifica la información de la encuesta</span>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Título</span>
            <input
              type="text"
              placeholder="Título de la encuesta"
              value={surveyToModForm.title}
              onChange={(e) => setSurveyToModForm((prev) => ({...prev, title: e.target.value}))}
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            <span className="text-xs font-bold w-1/3">Descripción</span>
            <textarea
              type="text"
              value={surveyToModForm.description}
              placeholder="Descripción de la encuesta"
              onChange={(e) => setSurveyToModForm((prev) => ({...prev, description: e.target.value}))}
              className="w-2/3 text-xs border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block py-1 w-full"
            />
          </div>


          <Button
            variant="contained"
            sx={{
              fontWeight: "bold",
              fontFamily: "poppins",
              paddingBlock: "4px",
              backgroundColor: "#ff6400",
              transform: "all",
              animationDuration: "1000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100%",
              fontSize: "small",
              '&:hover': {
                backgroundColor: "#bb4a03",
              }
            }}
            onClick={() => {
              updateSurvey()
              setSurveyInfoModal(false)
            }}
          >
            Actualizar encuesta
          </Button>
          
        </div>
      </Modal>

      {/*Body */}
      <div className="flex-grow flex flex-col">

        {/* Barra de info y data */}       
        <div className="flex flex-row items-center justify-end px-8 bg-gray-100 gap-8">

          <div>
            <Button 
              variant="contained"
              endIcon={<Add />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                padding: "4px 24px",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
              onClick={() => setNewSurveyModal(true)}
            >
              Crear nueva encuesta
            </Button>
          </div>

        </div>

        {loadingStatus ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>Cargando, por favor espera...</span>
                  <FaSpinner className="animate-spin text-gray-500" />
              </div>
            </div>
          ) : (
            surveys.length === 0 ? (
              <div className="flex w-full h-full text-gray-700 items-center justify-center">
                <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                    <span>No hay registros</span>
                    <FaInfoCircle className="text-gray-500" />
                </div>
              </div>
            ) : (
              !isSurveySelected ? (
                <table className="w-full table-fixed mt-2">
                  <thead className="bg-white sticky top-0 z-50">
                    <tr className="w-full text-gray-700 text-center text-sm uppercase font-semibold">
                      <th className="w-[2%] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div className="flex items-center justify-center">
                          <FaTrash />
                        </div>
                      </th>
                      <th className="w-[15%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Título
                      </th>
                      <th className="w-[20%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Descripción
                      </th>
                      <th className="w-[5%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Preguntas
                      </th>
                      <th className="w-[5%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Preguntas abiertas
                      </th>
                      <th className="w-[5%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Preguntas cerradas
                      </th>
                      <th className="w-[5%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Puntaje máximo
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {surveys.map((s, i) => (
                    <tr
                      key={i}
                      className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300"
                    >
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        <div
                          className="flex items-center justify-center hover:cursor-pointer transition-all duration-100" 
                          onClick={() => deleteSurvey(s.id)}
                        >
                          <FaTrash className="text-red-500"/>
                        </div>
                      </td>
                      <td scope="row" className="w-[15%] px-4 py-2 font-bold border border-gray-300 text-center hover:cursor-pointer hover:underline transition-all duration-100">
                        <div onClick={() => {
                            setSelectedSurvey(s)
                            setIsSurveySelected(true)
                          }}
                        >
                          {s.title}
                          {/* <br />{s.id} */}
                        </div>
                      </td>
                      <td scope="row" className="w-[20%] px-4 py-2 border border-gray-300 text-center transition-all duration-100">
                        {s.description}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.questions?.length}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.openQuestions}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.closeQuestions}
                      </td>
                      <td scope="row" className="px-4 py-2 border border-gray-300 text-center transition-all">
                        {s.questions?.reduce((acc, q) => {return acc + q.maxScore;}, 0)}
                      </td>
                    </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="flex flex-col w-full gap-4 p-4">

                {/* Header */}
                  <div className="flex flex-row justify-between items-center bg-gray-50 p-4 rounded-md shadow-md border border-gray-200">
                    
                    {/* Título y descripción */}
                    <div className="flex flex-col gap-2">
                      <h1 className="text-sm font-extrabold text-gray-700">{selectedSurvey?.title}</h1>
                      <p className="text-xs text-gray-600">{selectedSurvey?.description}</p>
                    </div>

                    {/* Botón de atrás y editar*/}
                    <div className="flex flex-col items-center justify-center gap-4">
                      <button
                        className="bg-blue-500 hover:bg-blue-600 text-white flex flex-row items-center justify-center gap-2 font-semibold text-xs py-1 px-4 rounded-md shadow-md transition-all duration-100"
                        onClick={() => setSurveyInfoModal(true)}
                      >
                        Editar
                        <FaEdit />
                      </button>
                      <button
                        className="bg-red-500 hover:bg-red-600 text-white flex flex-row items-center justify-center gap-2 font-semibold text-xs py-1 px-4 rounded-md shadow-md transition-all duration-100"
                        onClick={() => {
                          setIsSurveySelected(false);
                          setSelectedSurvey({});
                          getSurveys()
                        }}
                      >
                        Atrás
                        <FaArrowLeft />
                      </button>
                    </div>

                  </div>
  
                {/* Body */}
                <div className="grid grid-cols-4 gap-4 w-full items-start">
                  {selectedSurvey.questions.map((answer, index) => (
                      <div
                        key={index}
                        className="p-2 h-full bg-white rounded-lg shadow-md border border-gray-200"
                      >
                        <div className="flex h-full flex-col bg-gray-100 justify-between p-2 rounded-md gap-4"> 
                          <div className="flex flex-col justify-between h-full gap-2">
                  
                            <h2 className="text-xs font-semibold text-gray-700">
                              Pregunta {index + 1}: {answer?.description}
                            </h2>
                            <span className="text-xs">{answer?.type}</span>
                            
                              <div className="flex flex-row justify-between">
                                <span className="text-xs">{answer?.worker?.name}</span>
                                <div 
                                  className="flex flex-row gap-1 items-center hover:underline hover:cursor-pointer justify-center"
                                  onClick={() => { 
                                    setQuestionSelected(answer); 
                                    setModifyQuestionModal(true)
                                  }}
                                >
                                  <span className="text-xs text-gray-700">Editar </span>
                                  <FaEdit className="text-[10px] text-blue-500"/>
                                </div>
                                <div 
                                  className="flex flex-row gap-1 items-center hover:underline transition-all duration-100 hover:cursor-pointer justify-center"
                                  onClick={() => { 
                                    deleteQuestion(answer.id);
                                  }}
                                >
                                  <FaTrash className="text-[10px] text-red-400 hover:text-red-800 transition-all duration-100"/>
                                </div>
                              </div>

                          </div>
                        </div>
                      </div>
                    ))
                  }
                  <button
                    onClick={() => setNewQuestionModal(true)}
                    className="bg-blue-100 font-bold rounded-lg text-xs text-blue-500 py-8 h-full w-full shadow-md hover:bg-blue-200 hover:shadow-lg transition-all duration-200 flex-grow flex items-center justify-center gap-2"
                  >
                    <FaPlus /> Crear pregunta
                  </button>
                </div>
              </div>
              )
            )
          )
        }
      </div>

      {/* Paginador */}
      <div className="w-full flex flex-col gap-4 py-4 justify-center items-center ">
        <span className="text-sm text-gray-700 dark:text-gray-500 ">
          Mostrando
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {surveys.length}
          </span>{" "}
          de
          <span className="font-semibold text-gray-900 dark:text-gray-300 ">
            {" "}
            {totalDocs}
          </span>{" "}
          plantillas
        </span>
        <Pagination 
          count={totalPages}
          page={page}
          variant="outlined" 
          shape="rounded"
          onChange={handlePageChange}
        />
      </div>
    </>
  )
}

export default TablaPlantillas